import MutationTypes from 'baseapp/store/mutation-types'

let OperationStatus = {
  custom: 'custom', // {custom: {customid: ID, userid: ID, searchText: this.searchText, pageIndex: INDEX}}
  sysMessages: 'sysMessages', // {sysMessages: {pageIndex: INDEX}}
  goods: 'goods', // {goods: {firstCatgId: CATGID, secondCatgId: CATGID, PageIndex: INDEX}}
  orderList: 'orderList', // {orderList: {orderType: STATUS_ORDER_ALL, pageIndex: 1}}
  billDetailList: 'billdetailList', // {billDetailList: {pageIndex: this.pageIndex}}
  pointOrderList: 'pointOrderList', // {pointOrderList: {orderType: STATUS_ORDER_WILL_TRANSPORT}}
  certifyCenter: 'certifyCenter', // {certifyCenter: {certifyType: this.certifyType}}
  addCompany: 'addCompany', // { addCompany: {companyType: this.companyType, pageIndex: INDEX, searchText: this.searchText}}
  search: 'search', // { search: { pageIndex: INDEX, searchText: this.searchText}}
  selectCompany: 'selectCompany', // { selectCompany: { pageIndex: INDEX, searchText: this.searchText, selTypeArr: this.selTypeArr}}
  pricingManage: 'pricingManage', // { pricingManage: { pricingType: this.pricingType } }
  pricingManageItme: 'pricingManageItme', // { pricingManageItme: { skuName: skuName, customName: customName, contactName: contactName, contactMobile: contactMobile }}
  contractManage: 'contractManage', // { contractManage: { contractType: this.contractType } }
  contractItem: 'contractItem', // { contractItem: { companyid: buyer_companyid, contractname: name } }
  confirmRelation: 'confirmRelation', // { confirmRelation: { name: this.name, mobile: this.mobile, shopName: shop.shopname } }
  customRetail: 'customRetail', // { customRetail: { companyid: 0 } }
  selectCustom: 'selectCustom', // { selectCustom: { searchText: customName } }
  deliryOrder: 'deliryOrder', // { deliryOrder: { startTime: startTime, endTime: endTime, pageIndex: this.pageIndex }}
  sellerGoods: 'sellerGoods', // { sellerGoods: { isPriceSheetStatus: this.isPriceSheetStatus } }
  StoreCheckItem: 'StoreCheckItem', // { StoreCheckItem: { storeid: this.storeid, checkCode: this.checkCode, handle_userid: this.handle_userid } }
  companyReceivable: 'companyReceivable', // { companyReceivable: { startTime: this.getStartTime(), endTime: this.getEndTime() } }
  delieryOrderList: 'delieryOrderList', // { delieryOrder: { selDeliveryItemIndex: this.selDeliveryItemIndex } }
  customType: 'customType', // { customType: { customType: this.customType } }
  supplierSpuList: 'supplierSpuList', // { catgidList: this.catgList() }
  searchSupplier: 'searchSupplier', // { searchText: this.searchText, pageIndex: this.currentIndex }
  applyOrderList: 'applyOrderList', // {orderids: orderids}
  manageApproval: 'manageApproval', // { approvalType: this.approvalType }
  calendarReceivable: 'calendarReceivable', // { dateTimeArr: this.dateTimeArr, selDateTime: this.selDateTime, pageIndex, this.pageIndex }
  customCompanyPage: 'customCompanyPage' // { pageIndex: this.pageIndex }
}
class BaseOPStatusUtil {
  constructor (store) {
    this.store = store
  }

  static install (store) {
    let util = new BaseOPStatusUtil(store)
    if (typeof window !== 'undefined' && window.Vue) {
      window.Vue.prototype.$opstatusUtil = util
      window.Vue.$opstatusUtil = util
    }
  }

  _getStatus (key, defaultValue) {
    return this.store.getters.operationStatus(key, defaultValue)
  }

  _setStatus (key, value) {
    let status = {}
    status[key] = value
    this.store.commit(MutationTypes.SET_OPERATION_STATUS, status)
  }

  _deleteStatus (key) {
    this.store.commit(MutationTypes.DELETE_OPERATION_STATUS, key)
  }

  // sysMessages
  getSysMessageStatus (defaultValue) {
    return this._getStatus(OperationStatus.sysMessages, defaultValue)
  }

  setSysMessageStatus (value) {
    this._setStatus(OperationStatus.sysMessages, value)
  }

  deleteSysMessageStatus () {
    this._deleteStatus(OperationStatus.sysMessages)
  }

  // custom
  getCustomStatus (defaultValue) {
    return this._getStatus(OperationStatus.custom, defaultValue)
  }

  setCustomStatus (value) {
    this._setStatus(OperationStatus.custom, value)
  }

  deleteCustomStatus () {
    this._deleteStatus(OperationStatus.custom)
  }

  // goods
  getGoodsStatus (defaultValue) {
    return this._getStatus(OperationStatus.goods, defaultValue)
  }

  setGoodsStatus (value) {
    this._setStatus(OperationStatus.goods, value)
  }

  deleteGoodsStatus () {
    this._deleteStatus(OperationStatus.goods)
  }

  // orderList
  getOrderListStatus (defaultValue) {
    return this._getStatus(OperationStatus.orderList, defaultValue)
  }

  setOrderListStatus (value) {
    this._setStatus(OperationStatus.orderList, value)
  }

  deleteOrderListStatus () {
    this._deleteStatus(OperationStatus.orderList)
  }

  // billDetailList
  getBillDetailListStatus (defaultValue) {
    return this._getStatus(OperationStatus.billdetailList, defaultValue)
  }

  setBillDetailListStatus (value) {
    this._setStatus(OperationStatus.billdetailList, value)
  }

  deleteBillDetailListStatus () {
    this._deleteStatus(OperationStatus.billdetailList)
  }

  // pointOrderList
  getPointOrderListStatus (defaultValue) {
    return this._getStatus(OperationStatus.pointOrderList, defaultValue)
  }

  setPointOrderListStatus (value) {
    this._setStatus(OperationStatus.pointOrderList, value)
  }

  deletePointOrderListStatus () {
    this._deleteStatus(OperationStatus.pointOrderList)
  }
  // CertifyTypeStatus
  getCertifyCenterStatus (defaultValue) {
    return this._getStatus(OperationStatus.certifyCenter, defaultValue)
  }

  setCertifyCenterStatus (value) {
    this._setStatus(OperationStatus.certifyCenter, value)
  }

  deleteCertifyCenterStatus () {
    this._deleteStatus(OperationStatus.certifyCenter)
  }

  // addCompanyStatus
  getAddCompanyStatus (defaultValue) {
    return this._getStatus(OperationStatus.addCompany, defaultValue)
  }

  setAddCompanyStatus (value) {
    this._setStatus(OperationStatus.addCompany, value)
  }

  deleteAddCompanyStatus () {
    this._deleteStatus(OperationStatus.addCompany)
  }

  // search
  getSearchStatus (defaultValue) {
    return this._getStatus(OperationStatus.search, defaultValue)
  }

  setSearchStatus (value) {
    this._setStatus(OperationStatus.search, value)
  }

  deleteSearchStatus () {
    this._deleteStatus(OperationStatus.search)
  }

  // selectCompany
  getSelectCompany (defaultValue) {
    return this._getStatus(OperationStatus.selectCompany, defaultValue)
  }

  setSelectCompany (value) {
    this._setStatus(OperationStatus.selectCompany, value)
  }

  deleteSelectCompany () {
    this._deleteStatus(OperationStatus.selectCompany)
  }

  // pricingManage
  getPicingManageStatus (defaultValue) {
    return this._getStatus(OperationStatus.pricingManage, defaultValue)
  }

  setPicingManageStatus (value) {
    this._setStatus(OperationStatus.pricingManage, value)
  }

  deletePicingManageStatus () {
    this._deleteStatus(OperationStatus.pricingManage)
  }

  // pricingManageItme
  getPicingManageItemStatus (defaultValue) {
    return this._getStatus(OperationStatus.pricingManageItme, defaultValue)
  }

  setPicingManageItemStatus (value) {
    this._setStatus(OperationStatus.pricingManageItme, value)
  }

  deletePicingManageItemStatus () {
    this._deleteStatus(OperationStatus.pricingManageItme)
  }

  // contractManage
  getContractManageStatus (defaultValue) {
    return this._getStatus(OperationStatus.contractManage, defaultValue)
  }

  setContractManageStatus (value) {
    this._setStatus(OperationStatus.contractManage, value)
  }

  deleteContractManageStatus () {
    this._deleteStatus(OperationStatus.contractManage)
  }

  // contractItem
  getContractItemStatus (defaultValue) {
    return this._getStatus(OperationStatus.contractItem, defaultValue)
  }

  setContractItemStatus (value) {
    this._setStatus(OperationStatus.contractItem, value)
  }

  deleteContractItemStatus () {
    this._deleteStatus(OperationStatus.contractItem)
  }

  // confirmRelation
  getConfirmRelationStatus (defaultValue) {
    return this._getStatus(OperationStatus.confirmRelation, defaultValue)
  }

  setConfirmRelationStatus (value) {
    this._setStatus(OperationStatus.confirmRelation, value)
  }

  deleteConfirmRelationStatus () {
    this._deleteStatus(OperationStatus.confirmRelation)
  }

  // customRetail
  getCustomRetailStatus (defaultValue) {
    return this._getStatus(OperationStatus.customRetail, defaultValue)
  }

  setCustomRetailStatus (value) {
    this._setStatus(OperationStatus.customRetail, value)
  }

  deleteCustomRetailStatus () {
    this._deleteStatus(OperationStatus.customRetail)
  }

  // selectCustom
  getSelectCustomStatus (defaultValue) {
    return this._getStatus(OperationStatus.selectCustom, defaultValue)
  }

  setSelectCustomStatus (value) {
    this._setStatus(OperationStatus.selectCustom, value)
  }

  deleteSelectCustomStatus () {
    this._deleteStatus(OperationStatus.selectCustom)
  }

  // deliryOrder
  getDeliryOrderStatus (defaultValue) {
    return this._getStatus(OperationStatus.deliryOrder, defaultValue)
  }

  setDeliryOrderStatus (value) {
    this._setStatus(OperationStatus.deliryOrder, value)
  }

  deleteDeliryOrderStatus () {
    this._deleteStatus(OperationStatus.deliryOrder)
  }

  // sellerGoods
  getSellerGoodsStatus (defaultValue) {
    return this._getStatus(OperationStatus.sellerGoods, defaultValue)
  }

  setSellerGoodsStatus (value) {
    this._setStatus(OperationStatus.sellerGoods, value)
  }

  deleteSellerGoodsStatus () {
    this._deleteStatus(OperationStatus.sellerGoods)
  }

  // StoreCheckItem
  getStoreCheckItemStatus (defaultValue) {
    return this._getStatus(OperationStatus.StoreCheckItem, defaultValue)
  }

  setStoreCheckItemStatus (value) {
    this._setStatus(OperationStatus.StoreCheckItem, value)
  }

  deleteStoreCheckItemStatus () {
    this._deleteStatus(OperationStatus.StoreCheckItem)
  }

  setCompanyReceivableStatus (defaultValue) {
    this._setStatus(OperationStatus.companyReceivable, defaultValue)
  }

  getCompanyReceivableStatus (value) {
    return this._getStatus(OperationStatus.companyReceivable, value)
  }

  deleteCompanyReceivableStatus () {
    this._deleteStatus(OperationStatus.companyReceivable)
  }

  // deliryOrderList
  getDeliryOrderListStatus (defaultValue) {
    return this._getStatus(OperationStatus.delieryOrderList, defaultValue)
  }

  setDeliryOrderListStatus (value) {
    this._setStatus(OperationStatus.delieryOrderList, value)
  }

  deleteDeliryOrderListStatus () {
    this._deleteStatus(OperationStatus.delieryOrderList)
  }

  // customType
  getCustomTypeStatus (defaultValue) {
    return this._getStatus(OperationStatus.customType, defaultValue)
  }

  setCustomTypeStatus (value) {
    this._setStatus(OperationStatus.customType, value)
  }

  deleteCustomTypeStatus () {
    this._deleteStatus(OperationStatus.customType)
  }

  // supplierSpuList
  getSupplierSpuListStatus (defaultValue) {
    return this._getStatus(OperationStatus.supplierSpuList, defaultValue)
  }

  setSupplierSpuListStatus (value) {
    this._setStatus(OperationStatus.supplierSpuList, value)
  }

  deleteSupplierSpuListStatus () {
    this._deleteStatus(OperationStatus.supplierSpuList)
  }

  // searchSupplier
  getSearchSupplierStatus (defaultValue) {
    return this._getStatus(OperationStatus.searchSupplier, defaultValue)
  }

  setSearchSupplierStatus (value) {
    this._setStatus(OperationStatus.searchSupplier, value)
  }

  deleteSearchSupplierStatus () {
    this._deleteStatus(OperationStatus.searchSupplier)
  }

  // applyOrderList
  getApplyOrderListStatus (defaultValue) {
    return this._getStatus(OperationStatus.applyOrderList, defaultValue)
  }

  setApplyOrderListStatus (value) {
    this._setStatus(OperationStatus.applyOrderList, value)
  }

  deleteApplyOrderListStatus () {
    this._deleteStatus(OperationStatus.applyOrderList)
  }

  // manageApproval
  getManageApprovalStatus (defaultValue) {
    return this._getStatus(OperationStatus.manageApproval, defaultValue)
  }

  setManageApprovalStatus (value) {
    this._setStatus(OperationStatus.manageApproval, value)
  }

  deleteManageApprovalStatus () {
    this._deleteStatus(OperationStatus.manageApproval)
  }

  // calendarReceivable
  getCalendarReceivableStatus (defaultValue) {
    return this._getStatus(OperationStatus.calendarReceivable, defaultValue)
  }

  setCalendarReceivableStatus (value) {
    this._setStatus(OperationStatus.calendarReceivable, value)
  }

  deleteCalendarReceivableStatus () {
    this._deleteStatus(OperationStatus.calendarReceivable)
  }

  // customCompanyPage
  getCustomCompanyPageStatus (defaultValue) {
    return this._getStatus(OperationStatus.customCompanyPage, defaultValue)
  }

  setCustomCompanyPageStatus (value) {
    this._setStatus(OperationStatus.customCompanyPage, value)
  }

  deleteCustomCompanyPageStatus () {
    this._deleteStatus(OperationStatus.customCompanyPage)
  }
}

export default BaseOPStatusUtil



// WEBPACK FOOTER //
// ./src/apps/baseapp/store/baseOPStatusUtil.js